import {COUNTRY_CODES} from '@/utils/constants/countryConstants'
import {createSlice} from '@reduxjs/toolkit'

export const countryCodeInitialState = {
  countryCode: 'MX',
}

/**
 * @param {Object} state
 * @returns {import('@/utils/constants/countryConstants').CountryCode}
 */
export const selectCountryCode = state => state?.countryCode?.countryCode

/**
 * @param {import('@/utils/constants/countryConstants').CountryCode} code
 * @returns {(state: Object) => boolean}
 */
export const selectIsCountry = code => state => selectCountryCode(state) === code

export const selectIsIndia = selectIsCountry(COUNTRY_CODES.IND)
export const selectIsMexico = selectIsCountry(COUNTRY_CODES.MX)
export const selectIsNorthAmerica = selectIsCountry(COUNTRY_CODES.US)

const countryCodeSlice = createSlice({
  name: 'countryCode',
  initialState: countryCodeInitialState,
  reducers: {
    setCountryCode: (state, action) => {
      return {
        countryCode: action.payload,
      }
    },

    resetCountryCode: () => countryCodeInitialState,
  },
})

export const {setCountryCode, resetCountryCode} = countryCodeSlice.actions
export const countryCodeSliceReducer = countryCodeSlice.reducer
